export enum SignatureType {
  SIGNATURE = 'signature',
  APPROVE = 'approve',
  SEAL = 'seal'
}
